/**
 * SalesDashboardPresenter
 * --
 */
import { useState } from 'react';
import { Content, Title, Row, Col } from 'components';
import { Divider, Button, Table, Radio, Spin, Tabs } from 'antd';
import { ExportOutlined } from '@ant-design/icons';
import { strCut, stringToMoneyFormat, isMobile } from 'utils';
import moment from 'moment';
//
import TotalSalesStatus from './components/TotalSalesStatus';
// import OrderStatus from './components/OrderStatus';
import TotalSales from './components/TotalSales';
import StoreSales from './components/StoreSales';
// import NoticeList from './components/NoticeList';
// import InquiryList from './components/InquiryList';
// import ReviewList from './components/ReviewList';
import SaleDashboardSummary from 'routes/admin.routes/admin.sale/SaleDashboard';

/**----------------------------------------
 * [Component] 총관리자: 주문대시보드 - 프레젠터
 * ----------------------------------------
 */
const SalesDashboardPresenter = ({
  loading,
  startDate,
  endDate,
  orderList,
  storeSales,
  storeSales2,
  reviewList,
  inquiryList,

  currentShop,
  permission,
  summaryMode,
  defaultShopId,
}) => {
  /* ===== ROUTE ===== */
  /* ===== PROPS ===== */
  /* ===== STATE ===== */
  /* ===== FUNCTION ===== */
  /* ===== HOOKS ===== */
  /* ===== RENDER ===== */

  // JSX: start
  return (
    <Spin spinning={loading}>
      <Content
        maxWidth={'100%'}
        padding={isMobile ? 10 : 20}
        backgroundColor={'none'}
      >
        <Row>
          <Col x={24}>
            <Title
              size={3}
              style={{ marginBottom: 12 }}
              subButton={
                <span
                  style={{
                    color: '#717171',
                    fontWeight: 400,
                    fontSize: '0.85em',
                  }}
                >
                  {moment(endDate).format('YYYY년 MM월 DD일(ddd)')}
                </span>
              }
            >
              대시보드
            </Title>

            {/* === 현황 요약: start === */}
            {/* <OrderStatus
              loading={loading}
              data={orderList ? orderList[0] : []}
            /> */}
            <TotalSalesStatus
              loading={loading}
              mallList={orderList ?? []}
              storeList={storeSales ?? []}
              isMobile={isMobile()}
              currentShop={currentShop}
              permission={permission}
            />
            {/* === 현황 요약: end === */}

            {/* <Tabs
              type="card"
              size={'large'}
              defaultActiveKey="1"
              onChange={setCurrentTab}
              style={{
                padding: 0,
                marginTop: 10,
              }}
              items={[
                {
                  label: `전체 매출 현황`,
                  key: 'ALL',
                },
                {
                  label: `매장 매출 현황`,
                  key: 'ORDER',
                },
              ]}
            /> */}
            <br />
            <br />

            <Content
              maxWidth={'100%'}
              padding={0}
              backgroundColor={'#fff'}
              style={{ marginTop: -16 }}
            >
              {/* {currentTab === 'ALL' && (
              )}
              {currentTab === 'ORDER' && (
              )} */}
              <TotalSales
                list={[...(storeSales ?? [])]}
                mallList={orderList ?? []}
                tableList={storeSales2 ?? []}
                isMobile={isMobile()}
                currentShop={currentShop}
                permission={permission}
              />
            </Content>
            {/* <br />
            <br /> */}

            {/* === 요약정보 === */}
            {permission === 'STORE_ADMIN' && (
              <Content
                maxWidth={'100%'}
                padding={0}
                backgroundColor={'#fff'}
                style={{ marginTop: 15 }}
              >
                <SaleDashboardSummary
                  defaultShopId={currentShop}
                  permission={permission}
                  summaryMode={summaryMode}
                />
              </Content>
            )}

            {/* === === */}
            <Content
              maxWidth={'100%'}
              padding={0}
              backgroundColor={'#fff'}
              style={{ marginTop: 15 }}
            >
              <StoreSales
                data={storeSales}
                shopInformationData={storeSales2}
                isMobile={isMobile()}
                currentShop={currentShop}
                permission={permission}
              />
            </Content>

            {/* ==== ==== */}

            {/* ===== 차트: end ===== */}
          </Col>
        </Row>
      </Content>
    </Spin>
  ); // JSX: end
};

export default SalesDashboardPresenter;
